var map = {
	"./bergahorn-blatt.png": 31892,
	"./bergulme-blatt.png": 12419,
	"./birke-blatt.png": 81145,
	"./buche-blatt.png": 592,
	"./eiche-blatt.png": 39421,
	"./esche-blatt.png": 45531,
	"./esskastanie-blatt.png": 29461,
	"./flatter-ulme-blatt.png": 87379,
	"./ginkgo-blatt.png": 57816,
	"./gleditschie-blatt.png": 28465,
	"./hainbuche-blatt.png": 28764,
	"./platane-blatt.png": 8822,
	"./populus-blatt.png": 60276,
	"./robinie-blatt.png": 43509,
	"./rosskastanie-blatt.png": 70454,
	"./roteiche-blatt.png": 81161,
	"./schnurbaum-blatt.png": 42463,
	"./schwarzerle-blatt.png": 31061,
	"./schwarzkiefer-blatt.png": 96483,
	"./schwedische-mehlbeere-blatt.png": 73902,
	"./silberlinde-blatt.png": 13572,
	"./sommerlinde-blatt.png": 61811,
	"./spitzahorn-blatt.png": 62876,
	"./stechfichte-blatt.png": 80070,
	"./traubeneiche-blatt.png": 14012,
	"./vogelkirsche-blatt.png": 4512,
	"./walnuss-blatt.png": 49194,
	"./winterlinde-blatt.png": 2988,
	"./zerreiche-blatt.png": 28535,
	"./zitterpappel-blatt.png": 41969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63357;